import { configureStore } from "@reduxjs/toolkit";
import LoginSlice from "./redux/LoginSlice";
import SyncAllDataSlice from "./redux/SyncAllDataSlice";
import getProfileSlice from "./redux/profileSlice";
import postImageSlice from "./redux/ImageDetail";
import SyncAllTest from "./redux/SyncAllTest";
import SyncSingleData from "./redux/SyncSingleData";

// import rootReducer from './reducers'

const store = configureStore({
  reducer: {
    Signup: LoginSlice,
    SyncData: SyncAllDataSlice,
    profileData: getProfileSlice,
    imageUpload: postImageSlice,
    SyncTest:SyncAllTest,
    SyncDataSingle:SyncSingleData
  },
});

export default store;
